// import UserForm from '../../components/UserForm';
import {
  createProperEndpoint,
  getPropersEndpoint,
  deactivateProperEndpoint,
  activateProperEndpoint,
  updateProperPasswordEndpoint,
} from '../propers/services/properService';
import { UserManagerServices } from '../../hooks/useUserManager';
import UserGenericForm from '../../components/UserGenericForm';

const PropersUser = () => {
  const developerServices: UserManagerServices = {
    create: createProperEndpoint,
    list: (_contextId, token) => getPropersEndpoint(token),
    deactivate: deactivateProperEndpoint,
    activate: activateProperEndpoint,
    updatePassword: updateProperPasswordEndpoint,
  };

  return (
    <UserGenericForm
      services={developerServices}
      pageName="Propers"
      pageParentName="Usuarios Internos"
      getRolesPath={(userId) =>
        `/internal-users/propers/${userId}/roles-management`
      }
    />
  );
};

export default PropersUser;
